import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { Router } from '@angular/router';

@Component({
  selector: 'menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss'],
})
export class MenuSidebarComponent implements OnInit, OnDestroy {

  @Input() base: any;
  @Input() menu = [];
  @Input() url: Observable<string>;
  private inscricao = null;
  private inscricaoRouter: Subscription;
  private rexFragment = /(.*)#(.*)/;
  public menuTogggled = false;

  constructor(private router: Router) {}

  ngOnInit() {
    if (this.url) {
      this.inscricao = this.url.subscribe((url) => this.atualizarSituacaoMenu(url));
    }
  }

  ngOnDestroy() {
    if (this.inscricao) {
      this.inscricao.unsubscribe();
    }
    if (this.inscricaoRouter) {
      this.inscricaoRouter.unsubscribe();
    }
  }

  atualizarSituacaoMenu(url) {
    this.base.situacao = this.verificaSituacao(this.base, url) ? 1 : 0;
    this.menu = this.menu.map((item) => {
      item.situacao = this.verificaSituacao(item, url) ? 1 : 0;
      item.fragmento = this.separarFragmento(item.link);

      if (item.submenu) {
        item.submenu = item.submenu.map(subitem => {
          subitem.situacao = 0;
          subitem.fragmento = this.separarFragmento(subitem.link);
          if (this.verificaSituacao(subitem, url)) {
            subitem.situacao = 1;
            item.situacao = 2;
          }
          return subitem;
        });
      }
      return item;
    });
  }

  separarFragmento(link) {
    let fragmento = '';
    if (this.rexFragment.test(link)) {
      fragmento = this.rexFragment.exec(link)[2];
    }
    return fragmento;
  }

  verificaSituacao(menu, url) {
    if (menu.templateLink instanceof RegExp) {
      return menu.templateLink.test(url);
    }
    return menu.link === url;
  }

  // is fragment
  // is internal url
  // is external url
  tipo(submenu) {
    if (submenu.fragmento) {
      return 'frag';
    }

    if (submenu.link.substr(0, 4) === 'http') {
      return 'ext';
    }

    return 'int';
  }

  navegarComFragment(menu) {
    let fragment;
    let link;
    if (this.rexFragment.test(menu.link)) {
      fragment = this.rexFragment.exec(menu.link)[2];
      link = this.rexFragment.exec(menu.link)[1];
    }
    this.router.navigate([link], { fragment });
  }
}
